'use strict';

/**
 *
 * @name: nownessApp.baseComponents
 *
 */

 import NnBaseVideoDirective from './nn-base-video/nn-base-video.directive'
 import NnBaseButtonDirective from './nn-base-button/nn-base-button.directive'
 import NnBaseCheckboxDirective from './nn-base-checkbox/nn-base-checkbox.directive'
 import NnBaseInputDirective from './nn-base-input/nn-base-input.directive'
 import NnBaseModuleHeaderDirective from './nn-base-module-header/nn-base-module-header.directive'
 import NnBaseImgDirective from './nn-base-img/nn-base-img.directive'
 import NnBaseSvgDirective from './nn-base-svg/nn-base-svg.directive'
 import NnBaseSwiperDirective from './nn-base-swiper/nn-base-swiper.directive'
 import NnBaseSelectDirective from './nn-base-select/nn-base-select.directive'
 import NnBaseNotifyDirective from './nn-base-notify/nn-base-notify.directive'
 import NnBaseHeadingMediumDirective from './nn-base-heading-medium/nn-base-heading-medium.directive'
 import NnBaseFieldLabelDirective from './nn-base-field-label/nn-base-field-label.directive'

 const BaseComponentsModule = angular
  .module('nownessApp.baseComponents', [])
  .directive('nnBaseVideo', NnBaseVideoDirective)
  .directive('nnBaseButton', NnBaseButtonDirective)
  .directive('nnBaseCheckbox', NnBaseCheckboxDirective)
  .directive('nnBaseInput', NnBaseInputDirective)
  .directive('nnBaseModuleHeader', NnBaseModuleHeaderDirective)
  .directive('nnBaseImg', NnBaseImgDirective)
  .directive('nnBaseSvg', NnBaseSvgDirective)
  .directive('nnBaseSwiper', NnBaseSwiperDirective)
  .directive('nnBaseSelect', NnBaseSelectDirective)
  .directive('nnBaseNotify', NnBaseNotifyDirective)
  .directive('nnBaseHeadingMedium', NnBaseHeadingMediumDirective)
  .directive('nnBaseFieldLabel', NnBaseFieldLabelDirective)

export default BaseComponentsModule.name



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-components.module.js